import { Locales } from 'src/lib/constants';
import { NAVIGATION_EVENTS } from 'src/lib/trackingEvents';
import type { TFooterData } from 'src/store/navigation/footer';

export const footerData: TFooterData = {
  copyrightName: 'Plaid Inc.',
  eeaDisclaimer: [
    `Plaid B.V. is registered in the Netherlands with the Dutch Chamber of Commerce under number 74716603, is authorised and supervised by De Nederlandsche Bank (DNB) under registration number R179714, and with the Legal Identifier number (LEI) 7245006VF0O83RBSW372.`,
    `Plaid Financial Limited is a company incorporated in England and Wales under company number 11103959, authorised and regulated by the Financial Conduct Authority (FCA) under firm reference number 804718.`,
    `Each entity provides regulated open banking services, including Account Information Services (AIS) and/or Payment Initiation Services (PIS), under the EU Payment Services Directive (PSD2). Funds are not held by either entity and are not covered by the FSCS or Dutch Deposit Guarantee Scheme.`,
  ],
  hideCTAWhen: [
    '404',
    '500',
    'account-funding',
    'ach-start',
    'ACH-start',
    'assets',
    'auth',
    'balance',
    'banking',
    'business-brokerage-services',
    'business-finances',
    'careers',
    'consumer-payments',
    'contact-thanks',
    'contact',
    'customer-stories',
    'global',
    'how-it-works-for-consumers',
    'how-we-handle-data',
    'identity',
    'income',
    'integration',
    'investments',
    'job',
    'lending',
    'liabilities',
    'openings',
    'partners',
    'payment-initiation',
    'payments',
    'personal-finances',
    'plaid-exchange',
    'signup',
    'transactions',
    'use-cases',
    'wealth',
    'what-is-plaid',
    'why-is-plaid-involved',
    'trouble-connecting',
    '/', // The "/" represents homepage
  ],
  sections: {
    products: {
      header: 'Products',
      items: [
        {
          name: 'Auth',
          url: '/products/auth/',
        },
        {
          name: 'Link',
          url: '/plaid-link/',
        },
        {
          name: 'Payouts',
          url: '/products/payouts/',
        },
        {
          name: 'Identity Verification',
          url: '/products/identity-verification/',
        },
        {
          name: 'Variable Recurring Payments',
          url: '/products/variable-recurring-payments/',
        },
        {
          name: 'Transactions',
          url: '/products/transactions/',
        },
        {
          name: 'Balance',
          url: '/products/balance/',
        },
        {
          name: 'Assets',
          url: '/products/assets/',
        },
        {
          name: 'Monitor',
          url: '/products/monitor/',
        },
        {
          name: 'Identity',
          url: '/products/identity/',
        },
      ],
    },
    useCases: {
      header: 'Use cases',
      items: [
        {
          name: 'Personal financial management',
          url: '/use-cases/personal-finances/',
        },
        {
          name: 'Credit',
          url: '/solutions/credit/',
        },
        {
          name: 'Payments',
          url: '/use-cases/payments/',
        },
        {
          name: 'Business finances',
          url: '/use-cases/business-finances/',
        },
        {
          name: 'iGaming',
          url: '/use-cases/igaming/',
        },
        {
          name: 'Property management',
          url: '/plaid-for-property-management/',
        },
      ],
    },
    docs: {
      header: 'Developers',
      items: [
        {
          name: 'Quickstart',
          url: '/docs/quickstart/',
          locale: Locales.EN_US,
        },
        {
          name: 'API documentation',
          url: '/docs/',
          locale: Locales.EN_US,
        },
        {
          name: 'Libraries',
          url: '/docs/api/libraries/',
          locale: Locales.EN_US,
        },
        {
          name: 'GitHub',
          url: 'https://github.com/plaid',
        },
      ],
    },
    resources: {
      header: 'Resources',
      items: [
        {
          name: 'Pricing',
          url: '/pricing',
          trackingId: NAVIGATION_EVENTS.FOOTER.USER_CLICKED_FOOTER_NAV_PRICING,
        },
        {
          name: 'Customer stories',
          url: '/customer-stories/',
        },
        {
          name: 'Global coverage',
          url: '/global/',
        },
        {
          name: 'Company',
          url: '/company/',
        },
        {
          name: 'Blog',
          url: '/blog/',
          locale: Locales.EN_US,
        },
        {
          name: 'Contact',
          url: '/contact/',
        },
        {
          name: 'Careers',
          url: '/careers/',
          locale: Locales.EN_US,
        },
        {
          name: 'Safety',
          url: '/safety/',
        },
        {
          name: 'How we handle data',
          url: '/how-we-handle-data/',
        },
        {
          name: 'Legal',
          url: '/legal/',
          locale: Locales.EN_US,
        },
      ],
    },
  },
};
